// The machine and browser a ticket is filed from, so the form can preselect
// them. People can pick others: they may be reporting what they saw on
// their phone from a laptop.
//
// Same names and rules as flock's apps/support/useragent.py and the
// website's lib/device.js; flock accepts only these values. Keep them in step.

export const MACHINES = [
  'Windows desktop',
  'Mac',
  'Linux desktop',
  'Chromebook',
  'Android phone',
  'Android tablet',
  'iPhone',
  'iPad',
  'Other',
];

export const BROWSERS = ['Chrome', 'Edge', 'Firefox', 'Safari', 'Opera', 'Samsung Internet', 'Other'];

// Order matters: Edge, Opera and Samsung Internet also say 'Chrome', and
// Chrome also says 'Safari'.
const BROWSER_PATTERNS = [
  ['Edge', /Edg(?:e|A|iOS)?\/(\d+)/],
  ['Opera', /(?:OPR|Opera)\/(\d+)/],
  ['Samsung Internet', /SamsungBrowser\/(\d+)/],
  ['Firefox', /(?:Firefox|FxiOS)\/(\d+)/],
  ['Chrome', /(?:Chrome|CriOS)\/(\d+)/],
  ['Safari', /Version\/(\d+)[.\d]* (?:Mobile\/\S+ )?Safari\//],
];

export function machineFrom(ua, touchPoints = 0) {
  if (!ua) return 'Other';
  if (ua.includes('iPad')) return 'iPad';
  if (ua.includes('iPhone') || ua.includes('iPod')) return 'iPhone';
  // Android tablets drop 'Mobile' from the string.
  if (ua.includes('Android')) return ua.includes('Mobile') ? 'Android phone' : 'Android tablet';
  if (ua.includes('CrOS')) return 'Chromebook';
  if (ua.includes('Windows')) return 'Windows desktop';
  // iPads ask for the desktop site and say 'Macintosh'; only they have touch.
  if (ua.includes('Macintosh') || ua.includes('Mac OS X')) return touchPoints > 1 ? 'iPad' : 'Mac';
  if (ua.includes('Linux') || ua.includes('X11')) return 'Linux desktop';
  return 'Other';
}

// 'Chrome 155': the detected browser keeps its major version.
export function browserFrom(ua) {
  for (const [name, pattern] of BROWSER_PATTERNS) {
    const match = (ua || '').match(pattern);
    if (match) return `${name} ${match[1]}`;
  }
  return 'Other';
}

export function thisDevice() {
  if (typeof navigator === 'undefined') return { machine: 'Other', browser: 'Other' };
  const ua = navigator.userAgent || '';
  return { machine: machineFrom(ua, navigator.maxTouchPoints || 0), browser: browserFrom(ua) };
}

// The browser list for a form: the detected one (with its version) first.
export function browserChoices(detected) {
  return detected && !BROWSERS.includes(detected) ? [detected, ...BROWSERS] : BROWSERS;
}
